import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .component_team_info_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .component_info_btn {
    padding-right: 17px;
    padding-left: 17px;

    .anticon {
      margin-right: 12px;
    }
  }

  .component_team_member_search {
    margin-top: 24px;
    margin-bottom: 24px;
    height: 44px;
    border: 1px solid ${color.grey1};
    border-radius: 12px;
  }

  .component_team_content_item {
    display: flex;
    justify-content: space-between;
    column-gap: 12px;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid ${color.grey1};
  }

  .component_team_content_item_information {
    display: flex;
    align-items: center;

    .font-paragraph_medium {
      margin-right: 24px;
      text-transform: capitalize;
    }
  }

  .component_team_info_btn {
    margin-right: 12px;
  }
`;

export default Wrapper;
